module.exports = __webpack_public_path__ + "static/media/img_pc_device_bg01.b9c344b5.png";